// extracted by mini-css-extract-plugin
export var arrowed = "List-module--arrowed--0ee6f";
export var buttons = "List-module--buttons--f0eb5";
export var dotted = "List-module--dotted--74a0a";
export var list = "List-module--list--c8a4b";
export var none = "List-module--none--030bf";